export const suits = ['s', 'p', 'm', 'z'] as const;
export type Suit = (typeof suits)[number];

export const validValues = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '-',
  'X',
  '?',
];
export type ValidValue = (typeof validValues)[number];
export const nonPoints = ['-', 'X', '?'];

export interface Tile {
  id: string;
  value: ValidValue;
  suit?: Suit;
  modifier?: 'rotated' | 'stacked';
  aka?: boolean;
  open?: boolean;
}

export interface Meld {
  tiles: Tile[];
  Suit: Suit;
  isOpen: boolean;
}

export type Hand = Tile[];

export const tileSVGLookup: Record<Suit, { [key in ValidValue]: string }> = {
  s: {
    0: '/tiles/Sou5-Dora.svg',
    1: '/tiles/Sou1.svg',
    2: '/tiles/Sou2.svg',
    3: '/tiles/Sou3.svg',
    4: '/tiles/Sou4.svg',
    5: '/tiles/Sou5.svg',
    6: '/tiles/Sou6.svg',
    7: '/tiles/Sou7.svg',
    8: '/tiles/Sou8.svg',
    9: '/tiles/Sou9.svg',
  },
  p: {
    0: '/tiles/Pin5-Dora.svg',
    1: '/tiles/Pin1.svg',
    2: '/tiles/Pin2.svg',
    3: '/tiles/Pin3.svg',
    4: '/tiles/Pin4.svg',
    5: '/tiles/Pin5.svg',
    6: '/tiles/Pin6.svg',
    7: '/tiles/Pin7.svg',
    8: '/tiles/Pin8.svg',
    9: '/tiles/Pin9.svg',
  },
  m: {
    0: '/tiles/Man5-Dora.svg',
    1: '/tiles/Man1.svg',
    2: '/tiles/Man2.svg',
    3: '/tiles/Man3.svg',
    4: '/tiles/Man4.svg',
    5: '/tiles/Man5.svg',
    6: '/tiles/Man6.svg',
    7: '/tiles/Man7.svg',
    8: '/tiles/Man8.svg',
    9: '/tiles/Man9.svg',
  },
  z: {
    0: '/tiles/Blank.svg',
    1: '/tiles/Ton.svg',
    2: '/tiles/Nan.svg',
    3: '/tiles/Shaa.svg',
    4: '/tiles/Pei.svg',
    5: '/tiles/Haku.svg',
    6: '/tiles/Hatsu.svg',
    7: '/tiles/Chun.svg',
    8: '/tiles/Blank.svg',
    9: '/tiles/Blank.svg',
  },
};
